import {Controller} from "@hotwired/stimulus";
import Clipboard from "clipboard";
import {useModal} from "../../js/stimulus_use/use-modal";
import $ from "jquery";
import * as moment from "moment";


/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static outlets = [
        'share',
        'litigant--choose-or-create',
        'document--create-modal',
        'document--create-or-upload'
    ];

    static values = {
        litigantName: String,
        litigantId: Number,
        source: String,
        isViewed: Boolean,
        isGuideShown: Boolean,
        createAndUploadDocumentAvailable: Boolean,
    };

    static targets = [
        'litigantNameInHeader',
        'litigantName',
        'guide',
        'icon',
        'dontShowInput',
        'litigant',
        'form',
        'descriptionInput',
        'amountInput',
        'fees',
        'total',
        'messageInput',
        'messageFileAttachmentInput',
        'documentHasVatInput',
        'documentContainerInfoAndActions',
        'fileAttachmentInput',
        'fileAttachmentNames',
    ];

    dontShowAgainUrl = routes['app_payments_setdirectpaymentmodaltonotshowagain'];
    viewedUrl = routes['app_payments_setdirectpaymentmodalasviewed'];

    connect() {
        useModal(this, {
            withGuide: true,
            withViewed: true,
            withLitigant: true,
        });
    }

    onOpen() {
        this.documentCreateModalOutlet.openingModalController = this;
        if (this.createAndUploadDocumentAvailableValue) {
            this.documentCreateOrUploadOutlet.containerController = this;
        }

        if (this.litigantIdValue) {
            this.hideLitigant();
            this.showForm();
        } else {
            this.hideForm();
            this.showLitigant();
        }
    }

    onHide() {
        this.hideForm();
        this.hideLitigant();

        this.clearForm();
    }

    onLitigantShown() {
        dataLayer.push({
            "event": "dataLayer.gaEvent",
            "gaEvent": {
                "category": "Chat",
                "action": "Source-" + this.sourceValue + " Direct payment | Litigant",
                "label": GA_EVENT_LABEL,
            },
        });
    }

    showLitigantOrForm() {
        if (this.litigantIdValue) {
            this.showForm();
        } else {
            this.showLitigant();
        }
    }

    litigantChosenOrCreated() {
        this.hideLitigant();
        this.showForm();
    }

    showForm() {
        this.documentCreateModalOutlet.openingModalController = this;

        if (this.createAndUploadDocumentAvailableValue) {
            this.documentCreateOrUploadOutlet.containerController = this;
        }

        dataLayer.push({
            "event": "dataLayer.gaEvent",
            "gaEvent": {
                "category": "Chat",
                "action": "Source-" + this.sourceValue + " Direct payment | Form",
                "label": GA_EVENT_LABEL,
            },
        });

        if (this.litigantChooseOrCreateOutlet.getName() !== null) {
            $(this.litigantNameTarget).text(this.litigantChooseOrCreateOutlet.getName());
            $(this.litigantNameInHeaderTarget).text(this.litigantChooseOrCreateOutlet.getName());
        } else {
            $(this.litigantNameTarget).text(this.litigantNameValue);
            $(this.litigantNameInHeaderTarget).text(this.litigantNameValue);
        }

        this.formTarget.style.removeProperty('display');
    }

    hideForm(event) {
        event && event.preventDefault();

        this.formTarget.style.setProperty('display', 'none');
    }

    clearForm(event) {
        event && event.preventDefault();

        this.clearFormErrors();
        this.descriptionInputTarget.value = '';
        this.amountInputTarget.value = '';
        this.messageInputTarget.value = '';
        this.messageFileAttachmentInputTarget.value = '';
        this.fileAttachmentNamesTarget.value = '';
        $(this.messageFileAttachmentInputTarget).removeProp('files');
        $(this.fileAttachmentNamesTarget).text('')

        if (this.documentHasVatInput) {
            this.documentHasVatInputTarget.value = '';
        }

        if (this.documentHasVatInput) {
            this.documentHasVatInputTarget.value = '';
        }

        if (this.createAndUploadDocumentAvailableValue) {
            $(this.documentCreateOrUploadOutlet.documentContainerInfoAndActionsTarget).css('display', 'none')
            $(this.documentCreateOrUploadOutlet.documentContainerCreateOrUploadTarget).css('display', 'block')
            $(this.documentCreateOrUploadOutlet.bookingDocumentHtmlTarget).text('').val(null);
            $(this.documentCreateOrUploadOutlet.feeDocumentFileNameTarget).text('');
            $(this.documentCreateOrUploadOutlet.bookingDocumentHtmlTarget).val(null);
        }

        this.litigantChooseOrCreateOutlet.clear();
    }

    clearFormErrors() {
        this.litigantChooseOrCreateOutlet.clearErrors();

        this.formTarget.querySelectorAll('.is-invalid').forEach((element) => {
            element.classList.remove('is-invalid');
        });
    }

    submitForm(event) {
        event && event.preventDefault();

        this.clearFormErrors();

        let hasErrors = false;

        if (!this.descriptionInputTarget.value) {
            this.descriptionInputTarget.classList.add('is-invalid');
            hasErrors = true;
        }

        if (!this.amountInputTarget.value) {
            this.amountInputTarget.classList.add('is-invalid');
            hasErrors = true;
        }

        if (hasErrors) {
            return;
        }

        showPreloader();

        const formData = new FormData();
        formData.append('description', this.descriptionInputTarget.value);
        formData.append('amount', this.amountInputTarget.value);
        formData.append('with_short_url', true);
        formData.append('source', this.sourceValue);
        formData.append('message', this.messageInputTarget.value);
        formData.append('document', $(this.messageFileAttachmentInputTarget).prop('files')[0]);

        if (this.litigantIdValue) {
            formData.append('litigant_id', this.litigantIdValue)
        } else {
            const litigantData = this.litigantChooseOrCreateOutlet.getData();

            // foreach property of litigant data add to form data
            for (const [key, value] of Object.entries(litigantData)) {
                formData.append(key, value);
            }
        }

        if (this.createAndUploadDocumentAvailableValue) {
            const feeDocumentData = this.documentCreateOrUploadOutlet.getData();

            for (const [key, value] of Object.entries(feeDocumentData)) {
                formData.append(key, value);
            }
        }

        $.ajax({
            url: routes['app_payments_create'],
            data: formData,
            type: 'post',
            contentType: false,
            processData: false,
            success: (response) => {
                if (!response.status) {
                    hidePreloader();
                    addAlert('danger', response.message || translations['profile.An unknown error occurred.']);

                    return;
                }

                dataLayer.push({
                    "event": "dataLayer.gaEvent",
                    "gaEvent": {
                        "category": "Chat",
                        "action": "Source-" + this.sourceValue + " Direct payment | Submit",
                        "label": GA_EVENT_LABEL,
                    },
                });

                if (window.location.href === response.chat_url) {
                    location.reload()
                } else {
                    window.location.href = response.chat_url;
                }
            }
        }).fail(() => {
            hidePreloader();
            addAlert('danger', translations['profile.An unknown error occurred.']);
        });
    }

    getDataForCreateDocumentModal() {
        let data = {
            description: this.descriptionInputTarget.value,
            amount: this.amountInputTarget.value,
            vat: this.documentHasVatInputTarget.checked,
        };

        if (this.litigantIdValue) {
            data.litigant_id = this.litigantIdValue;
        } else {
            data = {
                ...data,
                ...this.litigantChooseOrCreateOutlet.getData(),
            };
        }

        return data;
    }

    fileAttachmentFieldChange() {
        let data = $(this.messageFileAttachmentInputTarget).prop('files');
        let filesTab = $(this.fileAttachmentNamesTarget)
        let fileNames = '';

        for (let i = 0; i < data.length; i++) {
            if (0 !== i) {
                fileNames += ", "
            }
            fileNames += (data[i].name + " ")
        }

        filesTab.text(fileNames);
    }
}
